import { useState, useCallback, useRef } from 'react';

export function useSwipeGesture({ onSwipeLeft, onSwipeRight, onSwipeDown, threshold = 50 }) {
  const [touchStart, setTouchStart] = useState({ x: null, y: null });
  const [touchEnd, setTouchEnd] = useState({ x: null, y: null });
  const [swiping, setSwiping] = useState(false);
  const startTime = useRef(null);

  const onTouchStart = useCallback((e) => {
    setTouchEnd({ x: null, y: null });
    setTouchStart({
      x: e.targetTouches[0].clientX,
      y: e.targetTouches[0].clientY
    });
    startTime.current = Date.now();
    setSwiping(true);
  }, []);

  const onTouchMove = useCallback((e) => {
    setTouchEnd({
      x: e.targetTouches[0].clientX,
      y: e.targetTouches[0].clientY
    });
  }, []);

  const onTouchEnd = useCallback(() => {
    if (!touchStart.x || !touchEnd.x) {
      setSwiping(false);
      return;
    }

    const distanceX = touchStart.x - touchEnd.x;
    const distanceY = touchStart.y - touchEnd.y;
    const timeDiff = Date.now() - startTime.current;

    // Only register swipe if it was fast enough (less than 500ms) and long enough
    const isValidSwipe = timeDiff < 500;

    // Check if horizontal swipe is dominant
    const isHorizontalSwipe = Math.abs(distanceX) > Math.abs(distanceY);

    if (isValidSwipe) {
      if (isHorizontalSwipe) {
        if (distanceX > threshold) {
          onSwipeLeft?.();
        } else if (distanceX < -threshold) {
          onSwipeRight?.();
        }
      } else {
        // Vertical swipe
        if (distanceY < -threshold) {
          onSwipeDown?.();
        }
      }
    }

    setSwiping(false);
  }, [touchStart, touchEnd, threshold, onSwipeLeft, onSwipeRight, onSwipeDown]);

  return {
    onTouchStart,
    onTouchMove,
    onTouchEnd,
    swiping
  };
}

export default useSwipeGesture;
